import { type Locale, SUPPORTED_LOCALES } from '@top/shared/src/Languages/types'

import DE from '../translations/de.json'
import EN from '../translations/en.json'
import ES from '../translations/es.json'
import FR from '../translations/fr.json'
import IT from '../translations/it.json'
import NL from '../translations/nl.json'

import { getPreferredLanguage } from './getPreferredLanguage'

const SYSTEM_MESSAGE_TRANSLATIONS = {
  EN,
  AR: EN,
  ZH: EN,
  NL,
  FR,
  DE,
  ID: EN,
  IT,
  JA: EN,
  KO: EN,
  PL: EN,
  PT: EN,
  RU: EN,
  ES,
  TH: EN,
  TR: EN,
  VI: EN,
  BG: EN,
  DA: EN,
  RO: EN,
  ET: EN,
  HY: EN,
  KA: EN,
} as const satisfies Record<Locale, object>

type SystemMessageKey = keyof (typeof SYSTEM_MESSAGE_TRANSLATIONS)[Locale]

const getSystemMessage = (key: SystemMessageKey, locale?: Locale) => {
  if (!locale) {
    const mutableSupportedLocales = SUPPORTED_LOCALES.map((l) => l)
    locale = getPreferredLanguage(mutableSupportedLocales).localeCode
  }
  return SYSTEM_MESSAGE_TRANSLATIONS[locale][key]
}

export default getSystemMessage
